<template>
  <div class="px-2 pt-4">
    <v-layout justify-center>
      <span><strong>LEGEND</strong></span>
    </v-layout>
    <v-layout justify-center class="legend-label">
      <v-flex md1><span class="spp-legend"/>&nbsp;SPP</v-flex>
      <!-- <v-flex md1><span class="sp-legend"/>&nbsp; SP</v-flex> -->
      <v-flex md1><span class="ppa-legend"/>&nbsp; PPA</v-flex>
      <v-flex md1><span class="legacy-legend"/>&nbsp; LEGACY</v-flex>
      <!-- <v-flex md1><span class="others-legend"/>&nbsp; OTHERS</v-flex> -->
    </v-layout>
    <v-layout>
      <v-flex md4 class="px-2">
        <material-chart-card
          :data="newAccountsChart.data"
          :options="newAccountsChart.options"
          :responsive-options="newAccountsChart.responsiveOptions"
          color="#43a047"
          type="Bar"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            New Accounts per Quarter
          </h4>
          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">Last updated: </span>
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md4 class="px-2">
        <material-chart-card
          :data="activeAccountsChart.data"
          :options="activeAccountsChart.options"
          :responsive-options="activeAccountsChart.responsiveOptions"
          color="#ff9900"
          type="Bar"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            Active Accounts per Quarter
          </h4>
          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">Last updated: </span>
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md4 class="px-2">
        <material-chart-card
          :data="suspendedAccountsChart.data"
          :options="suspendedAccountsChart.options"
          :responsive-options="suspendedAccountsChart.responsiveOptions"
          color="#ef5350"
          type="Bar"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            Suspended Accounts per Quarter
          </h4>
          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">Last updated: </span>
          </template>
        </material-chart-card>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-layout class="pt-5">
      <v-flex
        md3
        class="px-2"
      >
        <material-stats-card
          :value="lastQtrActiveAccounts"
          color="primary"
          icon="mdi-poll"
          title="Total Last Quarter End Active"
          sub-icon="mdi-calendar"
          sub-text="Just Updated"
        />
      </v-flex>
      <v-flex
        md3
        class="px-2"
      >
        <material-stats-card
          :value="reportCountThisQuarter"
          color="green"
          icon="mdi-poll"
          title="Total Reported Count this Quarter"
          sub-icon="mdi-calendar"
          sub-text="Just Updated"
        />
      </v-flex>
      <v-flex
        md3
        class="px-2"
      >
        <material-stats-card
          :value="suspendedLast90DaysAccounts"
          color="red"
          icon="mdi-poll"
          title="Total Number of accounts left the org(suspended) > 90 days"
          sub-icon="mdi-calendar"
          sub-text="Just Updated"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    acceptedMPTypes: ['ppa', 'spp', 'legacy', 'edp - vale'],
    quarters: [
      {
        text: `First Quarter (Dec 1 ${new Date().getFullYear()-1}-Feb 28 ${new Date().getFullYear()})`,
        value: 0,
        fromDate: `${new Date().getFullYear() - 1}-12-01`,
        toDate: `${new Date().getFullYear()}-02-28`
      },
      {
        text: `Second Quarter (Mar 1 ${new Date().getFullYear()}-May 31 ${new Date().getFullYear()})`,
        value: 1,
        fromDate: `${new Date().getFullYear()}-03-01`,
        toDate: `${new Date().getFullYear()}-05-31`
      },
      {
        text: `Third Quarter (Jun 1 ${new Date().getFullYear()}-Aug 31 ${new Date().getFullYear()})`,
        value: 2,
        fromDate: `${new Date().getFullYear()}-06-01`,
        toDate: `${new Date().getFullYear()}-08-31`
      },
      {
        text: `Fourth Quarter (Sep 1 ${new Date().getFullYear()}-Nov 30 ${new Date().getFullYear()})`,
        value: 3,
        fromDate: `${new Date().getFullYear()}-09-01`,
        toDate: `${new Date().getFullYear()}-11-30`
      }
    ],
    defaultChartOptions: {
      data: {
        labels: ['1ST QTR', '2ND QTR', '3RD QTR', '4TH QTR'],
        series: [],
      },
      options: {
        axisX: {
          showGrid: false
        },
        low: 0,
        high: 500,
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0,
        },
        height: '200px'
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0]
            },
          },
        }],
      ],
    },
  }),
  computed: {
    ...mapState('admin/accountInventory', ['masterAccounts', 'attestationReport']),
    newAccountsChart () {
      // get all new accounts
      let newAccounts = this.getAccountsByStatus('NEW')
      // set chart data
      let chartData = {
        data: {
          labels: ['1ST QTR', '2ND QTR', '3RD QTR', '4TH QTR'],
          series: [
            this.getQuarterlyAccountsByAgreement(newAccounts, 'spp'),
            // this.getQuarterlyAccountsByAgreement(newAccounts, 'sp'),
            this.getQuarterlyAccountsByAgreement(newAccounts, 'ppa'),
            this.getQuarterlyAccountsByAgreement(newAccounts, 'legacy'),
            // this.getQuarterlyAccountsByAgreement(newAccounts, 'other')
          ]
        }
      }
      // set chart options
      let chartOptions = {
        options: {
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          low: 0,
          high: this.getHighestCount(newAccounts),
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          },
          height: '200px'
        }
      }
      return { ...this.defaultChartOptions, ...chartOptions, ...chartData }
    },
    activeAccountsChart () {
      // get all active accounts
      let activeAccounts = this.getAccountsByStatus('ACTIVE')
      // set chart data
      let chartData = {
        data: {
          labels: ['1ST QTR', '2ND QTR', '3RD QTR', '4TH QTR'],
          series: [
            this.getQuarterlyAccountsByAgreement(activeAccounts, 'spp'),
            // this.getQuarterlyAccountsByAgreement(activeAccounts, 'sp'),
            this.getQuarterlyAccountsByAgreement(activeAccounts, 'ppa'),
            this.getQuarterlyAccountsByAgreement(activeAccounts, 'legacy'),
            // this.getQuarterlyAccountsByAgreement(activeAccounts, 'other')
          ]
        }
      }
      // set chart options
      let chartOptions = {
        options: {
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          low: 0,
          high: this.getHighestCount(activeAccounts),
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          },
          height: '200px'
        }
      }

      return { ...this.defaultChartOptions, ...chartOptions, ...chartData }
    },
    suspendedAccountsChart () {
      // get all active accounts
      let suspendedAccounts = this.getAccountsByStatus('SUSPENDED')
      // set chart data
      let chartData = {
        data: {
          labels: ['1ST QTR', '2ND QTR', '3RD QTR', '4TH QTR'],
          series: [
            this.getQuarterlyAccountsByAgreement(suspendedAccounts, 'spp'),
            // this.getQuarterlyAccountsByAgreement(suspendedAccounts, 'sp'),
            this.getQuarterlyAccountsByAgreement(suspendedAccounts, 'ppa'),
            this.getQuarterlyAccountsByAgreement(suspendedAccounts, 'legacy'),
            // this.getQuarterlyAccountsByAgreement(suspendedAccounts, 'other')
          ]
        }
      }
      // set chart options
      let chartOptions = {
        options: {
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          low: 0,
          high: this.getHighestCount(suspendedAccounts),
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          },
          height: '200px'
        }
      }
      return { ...this.defaultChartOptions, ...chartOptions, ...chartData }
    },
    lastQtrActiveAccounts () {
      let firstQuarter = null
      if (this.attestationReport.selectedQtr === 0) {
        let currentMonth = new Date().getMonth()
        // if current Month is December
        if (currentMonth === 11) {
          firstQuarter = {
            fromDate: `${new Date().getFullYear()}-09-01`,
            toDate: `${new Date().getFullYear()}-11-30`
          }
        } else {
          firstQuarter = {
            fromDate: `${new Date().getFullYear() - 1}-09-01`,
            toDate: `${new Date().getFullYear() - 1}-11-30`
          }
        }
      }
      // initialise
      let lastQuarterActiveAccounts = []
      // if select quarter is first
      // this.quarters
      // debugger
      if (firstQuarter) {
        lastQuarterActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(firstQuarter.toDate) && account.Acct_Status === 'ACTIVE' && this.acceptedMPTypes.includes(account.agreement))
      } else {
        lastQuarterActiveAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr - 1].toDate) && account.Acct_Status === 'ACTIVE' && this.acceptedMPTypes.includes(account.agreement))
      }

      return lastQuarterActiveAccounts.length
    },
    suspendedLast90DaysAccounts () {
      // Last_Date_Validated value should be more than 90 days up to todays' date and Account_Status is SUSPENDED
      let suspendedAccounts = this.masterAccounts.filter(account => {
        let dateSuspended = window.moment(account.Date_Suspended, 'YYYY-MM-DD')
        let lastDateValidated = window.moment(account.Last_Date_Validated, 'YYYY-MM-DD')
        let todaysDate = window.moment()
        return (window.moment.duration(todaysDate.diff(dateSuspended)).asDays() > 90 && account.Acct_Status === 'SUSPENDED' && this.acceptedMPTypes.includes(account.agreement)) || (window.moment.duration(todaysDate.diff(lastDateValidated)).asDays() > 90 && account.Acct_Status === 'SUSPENDED' && this.acceptedMPTypes.includes(account.agreement))
      })

      return suspendedAccounts.length
    },
    reportCountThisQuarter () {
      let reportedCountAccounts = this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(this.quarters[this.attestationReport.selectedQtr].fromDate) && window.moment(account.Date_onboarded) < window.moment(this.quarters[this.attestationReport.selectedQtr].toDate) && (account.Acct_Status === 'ACTIVE' || account.Acct_Status === 'SUSPENDED') && this.acceptedMPTypes.includes(account.agreement))

      return reportedCountAccounts.length
    }
  },
  methods: {
    getAccountsByStatus (status) {
      let accountsByStatus = []
      if (status === 'ACTIVE') {
        this.quarters.forEach(quarter => {
          accountsByStatus.push(this.masterAccounts.filter(account => account.Acct_Status === 'ACTIVE' && window.moment(account.Date_onboarded) < window.moment(quarter.toDate)))
        })
      } else if (status === 'NEW') {
        this.quarters.forEach(quarter => {
          accountsByStatus.push(this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(quarter.fromDate) && window.moment(account.Date_onboarded) < window.moment(quarter.toDate) && account.Acct_Status === 'ACTIVE'))
        })
      } else {
        this.quarters.forEach(quarter => {
          accountsByStatus.push(this.masterAccounts.filter(account => window.moment(account.Date_onboarded) > window.moment(quarter.fromDate) && window.moment(account.Date_onboarded) < window.moment(quarter.toDate) && account.Acct_Status === status))
        })
      }
      return accountsByStatus
    },
    getHighestCount (accounts) {
      return Math.max(
        ...[
          accounts[0].length,
          accounts[1].length,
          accounts[2].length,
          accounts[3].length
        ]
      )
    },
    getQuarterlyAccountsByAgreement (accounts, agreement) {
      // if (agreement === 'other') {
      //   return [
      //     accounts[0].filter(account => !['spp', 'sp', 'ppa', 'legacy'].includes(account.agreement)).length,
      //     accounts[1].filter(account => !['spp', 'sp', 'ppa', 'legacy'].includes(account.agreement)).length,
      //     accounts[2].filter(account => !['spp', 'sp', 'ppa', 'legacy'].includes(account.agreement)).length,
      //     accounts[3].filter(account => !['spp', 'sp', 'ppa', 'legacy'].includes(account.agreement)).length
      //   ]
      // } else {
        return [
          accounts[0].filter(account => account.agreement === agreement).length,
          accounts[1].filter(account => account.agreement === agreement).length,
          accounts[2].filter(account => account.agreement === agreement).length,
          accounts[3].filter(account => account.agreement === agreement).length
        ]
      // }
    }
  }
}
</script>
<style lang="scss">
.v-card--material-chart.v-card .v-card--material__header {
  max-height: 200px
}

.legend-label {

  span {
    height: 15px;
    width: 15px;
    display: inline-block;
  }
  .spp-legend {
    background-color: #fff;
  }
  .ppa-legend {
    background-color: #f05b4f;
  }
  .legacy-legend {
    background-color: #f4c63d;
  }
  // .legacy-legend {
  //   background-color: #d17905;
  // }.others-legend {
  //   background-color: #453d3f;
  // }
}
</style>
